import { render, staticRenderFns } from "./ArticleLikeList.vue?vue&type=template&id=b6a5a230&"
import script from "./ArticleLikeList.vue?vue&type=script&lang=js&"
export * from "./ArticleLikeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports